import React from 'react'

import { IconProps } from '../Types'

export const VoiceOffOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="VoiceOffOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m18.98,11c-.58,0-1,.42-1,1,0,.67-.17,1.33-.41,2-.25.67-.66,1.25-1.16,1.67-.5.5-1.08.83-1.66,1.17-.66.25-1.33.33-1.99.42h-2.07c-.58,0-1,.42-1.08.92,0,.58.41,1,.91,1.08h.5v1.75c0,.58.41,1,.99,1s1-.42,1-1v-1.75c.83,0,1.66-.25,2.49-.5.91-.33,1.66-.92,2.32-1.58.66-.67,1.16-1.5,1.58-2.33.33-.92.58-1.83.58-2.75,0-.58-.5-1.08-1-1.08Zm2.74-8.67c-.41-.42-1-.42-1.41,0l-3.81,3.83c-.08-1.08-.5-2.08-1.33-2.83-.83-.83-1.99-1.33-3.15-1.33s-2.24.5-3.07,1.33c-.83.83-1.33,2-1.33,3.17v4.83c0,.67.17,1.42.5,2,.17.25.33.5.5.75l-1.24,1.25c-.25-.33-.5-.75-.75-1.17-.33-.67-.5-1.42-.5-2.17,0-.58-.41-1-1-1s-1,.42-1,1c0,1,.25,2.08.66,3,.25.58.66,1.17,1.08,1.67l-3.57,3.58c-.41.42-.41,1,0,1.42.17.17.41.33.66.33s.5-.08.66-.33l12.27-12.33.08-.08,5.47-5.5c.66-.42.66-1,.25-1.42Zm-7.21,5.83l-4.48,4.5c-.08-.08-.08-.17-.17-.25-.17-.33-.25-.75-.25-1.08v-4.83c0-.67.25-1.25.75-1.75.5-.5,1.08-.75,1.74-.75s1.24.25,1.74.75.75,1.08.75,1.75v1.67h-.08Z"/><path d="m13.42,15.5c.17,0,.25,0,.41-.08.99-.42,1.82-1.25,2.24-2.25.25-.5,0-1.08-.5-1.33-.5-.25-1.08,0-1.33.5-.25.58-.66,1-1.24,1.25-.5.25-.75.83-.5,1.33.17.33.58.58.91.58Z"/>',
    }}
  />
)

VoiceOffOutline.displayName = 'VoiceOffOutline'

export const tags = ['VoiceOffOutline', '']
